import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import logodark from "../../../assets/images/logo.png"


//i18n
import { withTranslation } from "react-i18next";

import Admin from "./ADMIN";

const SidebarContent = (props) => {
  const { user, storeType, role, accessLevel, vendorStoreType } = props;
  console.log(role, "ROLEE");
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    let pathName = props.location.pathname;

    const pathNameArr = pathName.split("/");

    pathName = pathNameArr.slice(0, 2).join("/");

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  }

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <div className="dashlogo_box">
           <div className="logo_dashboard">
             <img src={logodark} alt="" className="img-fluid"/>
           </div>
           <h5>{props.t("main_menu")}</h5>
        </div>
        <ul className="metismenu list-unstyled" id="side-menu">
          <Admin />
        </ul>
      </div>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  storeType: PropTypes.array,
  role: PropTypes.string,
};

const mapStateToProps = ({ Login, Settings }) => ({
  storeType: Settings?.settings?.storeTypeEnabled || [],
  user: Login?.user,
  role: Login?.user?.role || "",
  accessLevel: Login?.user?.accessLevel,
  vendorStoreType: Login?.user?.storeType || [],
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(SidebarContent))
);
